export default "__VITE_ASSET___xKZKRRIp5eLcuPn_tnqfg__"